<template>
    <div>
        <div v-if="ajax_loader" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
            <div>
                <h3 class="text-secondary text-capitalize fw-500 mb-0 fs-20">
                    <span v-if="$route.path == '/pm/ticketdetails'">
                        PM
                    </span>
                    {{ active_tab }} Tickets
                </h3>
                <div class="text-light-blue">{{ status_based_total > 999 ? status_based_total.toLocaleString() :
            status_based_total }} Total</div>
            </div>
            <div class="d-flex align-items-center mt-1">
                <button class="btn btn-success-outline btn-smm ml-2" style="" @click="createTickets()">
                    <i class="ri-2x ri-add-circle-fill"></i>
                    <span class="ml-1 hidden-sm-down fs-13">New Ticket</span>
                </button>
                <button class="btn btn-secondary btn-smm ml-2 d-flex align-items-center justify-content-center"
                    style="border-radius: 5px !important" @click="showFilters()">
                    <!-- <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/filter.svg" class="mb-1"> -->
                    <img src="/static/images/new-theme2024/equalizer-fill-white.svg" alt="" width="20">
                    <span class="text-white ml-1 hidden-sm-down fs-13">Filter</span>
                </button>
            </div>
        </div>
        <div class="table-content mb-3" style="overflow-x: auto !important;">
            <table class="table table-content-data table-responsive">
                <thead>
                    <tr>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('status')" class="cursor-th pl-7">
                                Ticket Status
                                <span v-if="passed_key.key == 'status' && passed_key.value == -1"
                                    :class="{ 'hide-arrow': passed_key.key != 'status' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else
                                    :class="{ 'hide-arrow': passed_key.key != 'status' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('ticket_number')" class="cursor-th">
                                Ticket ID
                                <span v-if="passed_key.key == 'ticket_number' && passed_key.value == -1"
                                    :class="{ 'hide-arrow': passed_key.key != 'ticket_number' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else
                                    :class="{ 'hide-arrow': passed_key.key != 'ticket_number' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('subject')" class="cursor-th">
                                Subject
                                <span v-if="passed_key.key == 'subject' && passed_key.value == -1"
                                    :class="{ 'hide-arrow': passed_key.key != 'subject' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else
                                    :class="{ 'hide-arrow': passed_key.key != 'subject' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('assigned_to')" class="cursor-th">
                                Assigned To
                                <span v-if="passed_key.key == 'assigned_to' && passed_key.value == -1"
                                    :class="{ 'hide-arrow': passed_key.key != 'assigned_to' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else
                                    :class="{ 'hide-arrow': passed_key.key != 'assigned_to' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('created_date')" class="cursor-th">
                                Creation Date
                                <span v-if="passed_key.key == 'created_date' && passed_key.value == -1"
                                    :class="{ 'hide-arrow': passed_key.key != 'created_date' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else
                                    :class="{ 'hide-arrow': passed_key.key != 'created_date' }" class="sorting-icon">
                                    <i class="text-secondary ri-2x ri-arrow-up-down-line"
                                        style="font-size: 12px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span class="cursor-th">
                                Created By
                            </span>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="ajaxCallInProgress" class="text-center font-weight-bold"
                        style="background-color: #eff9fd !important;">
                        <td colspan="9" style="height: 300px;">
                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f"
                                class="text-center w-100 d-flex align-item-center justify-content-center" />
                        </td>
                    </tr>
                    <tr v-if="!ajaxCallInProgress && allTickets.length == 0"
                        class="text-center font-weight-bold ht-100px">
                        <td colspan="9">No Tickets Found</td>
                    </tr>
                    <tr v-else v-for="ticket in allTickets" :key="ticket.ticket_id">
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            <button style="text-transform: capitalize; width: 110px !important;"
                                class="btn btn-smm text-white btn-default btn-width btn-success-border-radius" :class="{
            'btn-open-status-newtheme': ticket.status == 'Open',
            'btn-assigned': ticket.status == 'Assigned',
            'btn-review': ticket.status == 'Review',
            'btn-hex-gray38': ticket.status == 'Unassigned',
            'btn-grid-inprogress-newtheme': ticket.status == 'In progress',
            'btn-fixed-newtheme': ticket.status == 'Fixed',
            'btn-closed-newtheme': ticket.status == 'Closed',
            'btn-reopen-newtheme': ticket.status == 'Re-Open',
            'btn-moonlight-sage': ticket.status == 'Reject',
            'btn-schedule': ticket.status == 'Scheduled',
            'btn-approved': ticket.status == 'Approved',
            'rejected-btn': ticket.status == 'Rejected'
        }">
                                {{ ticket.status }}
                            </button>
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            <span class="pointer text-secondary">{{ "#" + ticket.ticket_number }}</span>
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            <span class="caps"
                                style="max-width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;">{{
            ticket.subject }}</span>
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            {{ ticket.assigned_to || '-' }}
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            {{ ticket.created_date }}
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            {{ ticket.created_by || '-' }}
                        </td>
                        <td class="whiteSpace w-1 pointer">
                            <span class="action-btns-show-hide"
                                v-if="ticket.template_type == 'default' || (ticket.hasOwnProperty('approve_data') && ticket.approve_data.length <= 0 && ticket.template_type == 'multi_part') || ticket.status == 'Closed'">
                                <el-popover placement="bottom-start" width="150" trigger="click" v-if="!showChange">
                                    <div class="fw-500 p-2"
                                        v-if="(ticket.hasOwnProperty('approve_data') && ticket.approve_data.length <= 0 && ticket.template_type == 'multi_part') || ticket.template_type == 'default'"
                                        @click="showAllStatus(ticket)">Change Status</div>
                                    <div class="fw-500 p-2" style="font-size:14px !important"
                                        v-if="ticket.status == 'Closed'" @click="ticketDelete(ticket)">Archive</div>
                                    <el-button slot="reference" style="border:none !important;background:transparent;">
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/more.svg"
                                            alt="">
                                    </el-button>
                                </el-popover>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end">
            <div class="d-flex align-items-center">
                <div class="pagination">
                    <ul>
                        <li class="btn navigate-btn" @click="previousPage()" :disabled="skip === 0">
                            <span><i class="icon icon-chevron-left"></i></span>
                        </li>
                        <template v-if="total_pages <= 10">
                            <li v-for="page in total_pages" :key="page" class="numb"
                                :class="{ active: page === curr_page }" @click="createPagination(page)">
                                <span>{{ page }}</span>
                            </li>
                        </template>
                        <template v-else>
                            <li class="numb" @click="createPagination(1)" :class="{ active: curr_page === 1 }">
                                <span>1</span>
                            </li>
                            <li v-if="curr_page > 4" class="dots"><span>...</span></li>
                            <li v-for="index in Math.min(curr_page + 2, total_pages) - Math.max(curr_page - 2, 1) + 1"
                                :key="Math.max(curr_page - 2, 1) + index - 1"
                                v-if="Math.max(curr_page - 2, 1) + index - 1 <= total_pages && Math.max(curr_page - 2, 1) + index - 1 >= 2"
                                class="numb" :class="{ active: Math.max(curr_page - 2, 1) + index - 1 === curr_page }"
                                @click="createPagination(Math.max(curr_page - 2, 1) + index - 1)">
                                <span>{{ Math.max(curr_page - 2, 1) + index - 1 }}</span>
                            </li>
                            <li v-if="curr_page < total_pages - 3" class="dots"><span>...</span></li>
                            <li v-if="total_pages > 5 && !lastPageClicked && curr_page <= total_pages - 3" class="numb"
                                @click="createPagination(total_pages)">
                                <span>{{ total_pages }}</span>
                            </li>
                        </template>
                        <li class="btn navigate-btn" @click="nextPage()" :disabled="skip + limit >= total">
                            <span><i class="icon icon-chevron-right"></i></span>
                        </li>
                    </ul>
                </div>
                <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide" :options="pageLimit"
                    :close-on-select="true" v-model.number="limit" @select="getAllTicketAPI" open-direction="top"
                    :show-labels="false" placeholder=""
                    style="width: 3em !important;padding-right: 10px!important; text-align: center !important;">
                    <template slot="singleLabel">
                        {{ limit }}
                    </template>
                </multiselect>
                <span><strong>/pages</strong></span>

            </div>
        </div>

        <!-- <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end" v-if="total > 0">
            <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                :options="pageLimit" :close-on-select="true" v-model.number="limit"
                @select="getAllTicketAPI"
                open-direction="top" :show-labels="false" placeholder=""
                style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                style="margin-left: -35px;">
            <span class="page-info pr-2 pl-6 fw-500"
                style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                    <i class="icon-chevron-double-left"></i>
                </el-tooltip>
            </button>
            <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                    <i class="icon icon-chevron-left"></i>
                </el-tooltip>
            </button>
            <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
            <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                    <i class="icon icon-chevron-right"></i>
                </el-tooltip>
            </button>
            <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                    <i class="icon-chevron-double-right"></i>
                </el-tooltip>
            </button>
        </div> -->
        <!-- <div v-if="display_filters" class="top_curve fadeInDown pb-3" :class="{'fadeInUp':hide_filters == true}"></div> -->
        
        <div v-if="display_filters" class="scm-filters overflow-visible">
            <filter-data @hideFilters="hideFilters" :showfilterData="showfilterData" @appliedFilter="appliedFilter"
                @showSuccessPopup="showSuccessPopup" @openSaveFilter="openSaveFilter"
                @hideSuccessPopup="hideSuccessPopup" @showWarningPopup="showWarningPopup"
                @hideWarningPopup="hideWarningPopup"></filter-data>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{ success_msg }}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{ warning_msg }}</sweet-modal>
        <filter-save-modal modal_name="save-filter" @filterSaved="filterSaved"></filter-save-modal>
        <change-status @cancelStatus="cancelStatus" :template_type="template_type" @updateStatus="updateStatus()"
            v-if="showChange" modal_name="status-change" :ticket_id="ticket_id" :status="ticketStatus"
            :closed_ticket="closed_ticket"></change-status>
    </div>
</template>
<script>
import ticket from '../mixins/ticket.js';
import Swal from 'sweetalert2';
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from '../eventBus/nav-bar-event.js';
import FilterSaveModal from "../ArchieveTickets/FilterSaveModal";
const FilterData = () => import('./FilterData')
const ChangeStatus = () => import("./ChangeStatus")
export default {
    components: {
        Swal,
        FilterData,
        FilterSaveModal,
        SweetModal,
        ChangeStatus
    },
    mixins: [ticket],
    props: ['active_tab'],
    data() {
        return {
            passed_key: {
                key: 'created_date',
                value: -1
            },
            curr_page: 1,
            lastPageClicked: false,


            status_based_total: 0,
            display_filters: false,
            hide_filters: false,
            search_key: '',
            skip: 0,
            limit: 10,
            total: 0,
            search_key: '',
            count: 0,
            ajaxCallInProgress: false,
            allTickets: [],
            total_pages: 0,
            // curr_page: 10,
            temp_total: 0,
            skip_temp: 0,
            success_msg: '',
            warning_msg: '',
            selectedTicket: null,
            status: [],
            ticket_id: '',
            ticketStatus: '',
            showChange: false,
            closed_ticket: {},
            showfilterData: {
                created_templates: [],
                approvers: [],
                assigned_to: [],
                branch: [],
                company_name: [],
                created_date: [],
                department: [],
                last_modified_date: [],
                priority: [],
                product: [],
                status: [],
                ticket_number: [],
                template: [],
                behalf_selected: [],
                behalf_of_whom: 'customer',
                assign_to_whom: 'person',
                ticket_type: '',
                created_tags: [],
                saveFilter: null
            },
            filterData: {
                created_templates: [],
                assigned_to: [],
                branch: [],
                approvers: [],
                company_name: [],
                created_date: [],
                department: [],
                last_modified_date: [],
                priority: [],
                product: [],
                status: [],
                ticket_number: [],
                template: [],
                behalf_selected: [],
                behalf_of_whom: 'customer',
                assign_to_whom: 'person',
                ticket_type: '',
                created_tags: [],
            },
            template_type: '',
            ajax_loader: false,
            save_filter_params: '',
            pageLimit: [],
        }
    },
    methods: {
        openSaveFilter(filter_data) {
            this.save_filter_params = {
                name: '',
                filters: filter_data
            }
            setTimeout(() => {
                this.$modal.show('save-filter');
            }, 500);
        },
        async filterSaved(value) {
            try {
                this.save_filter_params.name = value
                let params = this.save_filter_params
                let res = await this.filterSave(params)
                this.success_msg = res.response.success_message
                this.$refs.success_modal.open()
                setTimeout(() => {
                    this.$refs.success_modal.close()
                }, 1000);
                setTimeout(() => {
                    EventBus.$emit('clear_selected_filter')
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open()
                setTimeout(() => {
                    this.$refs.warning_modal.close()
                }, 1000);
            }
        },
        cancelStatus() {
            this.showChange = false
        },
        updateStatus() {
            this.showChange = false;
            this.getAllTicketAPI();
        },
        showSuccessPopup(msg) {
            this.success_msg = msg;
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.$refs.success_modal.close();
            }, 3000);
        },
        showWarningPopup(msg) {
            this.warning_msg = msg;
            this.$refs.warning_modal.open();
            setTimeout(() => {
                this.$refs.warning_modal.close();
            }, 3000);
        },
        appliedFilter(data) {
            this.filterData = {
                created_templates: data.value.created_templates,
                created_tags: data.value.created_tags,
                assigned_to: data.value.assigned_to,
                approvers: data.value.approvers,
                branch: data.value.branch,
                company_name: data.value.company_name,
                created_date: data.value.created_date,
                department: data.value.department,
                last_modified_date: data.value.last_modified_date,
                priority: data.value.priority,
                product: data.value.product,
                status: data.value.status,
                ticket_number: data.value.ticket_number,
                template: data.value.template,
                assign_to_whom: data.value.assign_to_whom,
                behalf_of_whom: data.value.behalf_of_whom,
                behalf_selected: data.value.behalf_selected,
                ticket_type: data.value.ticket_type
            }
            this.showfilterData = {
                saveFilter: data.value1.saveFilter,
                created_templates: data.value1.created_templates,
                created_tags: data.value1.created_tags,
                assigned_to: data.value1.assigned_to,
                approvers: data.value1.approvers,
                branch: data.value1.branch,
                company_name: data.value1.company_name,
                created_date: data.value1.created_date,
                department: data.value1.department,
                last_modified_date: data.value1.last_modified_date,
                priority: data.value1.priority,
                product: data.value1.product,
                status: data.value1.status,
                ticket_number: data.value1.ticket_number,
                template: data.value1.template,
                assign_to_whom: data.value1.assign_to_whom,
                behalf_of_whom: data.value1.behalf_of_whom,
                behalf_selected: data.value1.behalf_selected,
                ticket_type: data.value.ticket_type
            }
            this.getAllTicketAPI()
        },
        showAllStatus(ticket) {
            this.ticket_id = ticket.ticket_id
            this.ticketStatus = ticket.status
            this.template_type = ticket.template_type
            this.closed_ticket = {
                ticket_number: ticket.ticket_number,
                company: ticket.company_name,
                subject: ticket.subject,
                author_name: ticket.created_by,
                assigned_to: ticket.assigned_to,
                description: ticket.description,
                ticket_id: ticket.ticket_id
            }
            this.showChange = true
            setTimeout(() => {
                this.$modal.show('status-change');
            }, 500);
        },
        ticketDetails(ticket) {
            let newData = {
                filterData: this.filterData,
                showfilterData: this.showfilterData
            }
            localStorage.setItem("StoreFilterData", JSON.stringify(newData))
            this.$router.push({
                path: `/ticketdetails/${ticket.ticket_id}`,
                query: {
                    type: 'normal_ticket',
                    from_filtered_status: this.$route.query.view_ticket || 'Overall'
                }
            }
            ).catch((err) => {
                console.log(err)
            });
            EventBus.$emit('tabactivate', ticket)
        },
        // changePage(){
        //     const element = document.querySelector('.pagination ul')
        //     let liTag = ''
        //     let active
        //     let prev_page = this.curr_page - 1;
        //     let after_curr_page = this.curr_page + 1;
        //     if(this.curr_page > 1){
        //         liTag += `<li class="btn navigate-btn" onclick="createPagination(this.total_pages, ${this.curr_page - 1})"><span><i class="icon icon-chevron-left"></i></span></li>`
        //     }
        //     if(this.curr_page > 2){
        //         liTag += '<li class="dots"><span>...</span></li>'
        //     }
        //     if(this.curr_page == this.total_pages){
        //         prev_page = prev_page - 2;
        //     } else if(this.curr_page == this.total_pages - 1){
        //         prev_page = prev_page - 1;
        //     }

        //     if(this.curr_page == 1){
        //         after_curr_page = after_curr_page + 2;
        //     } else {
        //         after_curr_page = after_curr_page + 1
        //     }

        //     for(var plength = prev_page; plength <= after_curr_page; plength++){
        //         if(plength > this.total_pages){
        //             continue;
        //         }
        //         if(plength == 0){
        //             plength = plength + 1;
        //         }
        //         if(this.curr_page == plength){
        //             active = "active"
        //         } else {
        //             active = ''
        //         }
        //         liTag += `<li class="numb ${active}" onclick="createPagination(this.total_pages, ${plength})"><span>${plength}</span></li>`
        //     }

        //     if(this.curr_page < this.total_pages - 1){
        //         liTag += `<li class="dots"><span>...</span></li>`
        //     }
        //     // if(this.curr_page < this.total_pages){
        //     //     liTag += `<li class="last numb" onclick="createPagination(this.total_pages, ${this.total_pages})"><span>${this.total_pages}</span></li>`
        //     // }
        //     if (this.curr_page < this.total_pages) { //show the next button if the page value is less than totalPage(20)
        //         liTag += `<li class="btn navigate-btn" onclick="createPagination(this.total_pages, ${this.curr_page + 1})"><span><i class="icon icon-chevron-right"></i></span></li>`;
        //     }
        //     element.innerHTML = liTag; //add li tag inside ul tag
        //     // return liTag;
        // },
        setPasskey: function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            this.getAllTicketAPI()
        },
        showFilters() {
            if (this.display_filters) {
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else {
                this.display_filters = true
            }
        },
        hideFilters() {
            this.hide_filters = true
            this.display_filters = false
            setTimeout(() => {
                this.hide_filters = false
            }, 500);
        },
        firstPage() {
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            this.allTickets = []
            this.getAllTicketAPI()
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total / this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getAllTicketAPI();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            this.temp_total = this.skip_temp;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.curr_page = Math.ceil(this.skip / this.limit) + 1;
            this.getAllTicketAPI();
        },
        previousPage() {
            this.temp_total = 0;
            this.skip_temp = 0;
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.curr_page = Math.ceil(this.skip / this.limit) + 1;
            this.getAllTicketAPI();
        },

        createPagination(page) {
            if (page === this.curr_page) {
                return;
            }
            this.curr_page = page;
            this.skip = (page - 1) * this.limit;
            this.getAllTicketAPI();
        },
        

        createTickets() {
            let ticket = {
                ticket_id: '',
                ticket_number: ''
            }
            localStorage.setItem("parentTicketDetails", JSON.stringify(ticket))
            this.$router.push({ name: "TicketsCreate" });
        },
        async getAllTicketAPI() {
            this.status_based_total = 0
            this.total_pages = parseInt(this.status_based_total / this.limit)
            this.filterData.status.forEach((element, index) => {
                if (this.filterData.status[index] == 'in progress') {
                    this.filterData.status[index] = 'inprogress'
                }
                if (this.filterData.status[index] == 'Reopen' || this.filterData.status[index] == 'reopen') {
                    this.filterData.status[index] = 'reopened'
                }
            });
            try {
                this.ajaxCallInProgress = true
                this.allTickets = []
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                    is_mobile: false,
                    sort_key: this.passed_key.key,
                    is_service_ticket: false,
                    filters: {
                        sort_value: this.passed_key.value,
                        assigned_to: {
                            select_all: false,
                            to: this.filterData.assign_to_whom,
                            value: this.filterData.assigned_to
                        },
                        branch: {
                            value: this.filterData.branch
                        },
                        company_name: {
                            value: this.filterData.company_name
                        },
                        date_range: {
                            created_date: this.filterData.created_date,
                            modification_date: this.filterData.last_modified_date,
                        },
                        department: {
                            value: this.filterData.department
                        },
                        priority: {
                            value: this.filterData.priority
                        },
                        product: {
                            select_all: false,
                            value: this.filterData.product
                        },
                        status: {
                            value: this.filterData.status,
                            select_all: false
                        },
                        ticket_number: {
                            select_all: false,
                            value: this.filterData.ticket_number
                        },
                        on_behalf_of: {
                            for: this.filterData.behalf_of_whom,
                            select_all: false,
                            value: this.filterData.behalf_selected
                        },
                        ticket_type: this.filterData.ticket_type,
                        tag: {
                            select_all: false,
                            value: this.filterData.created_tags,
                        },
                        template: {
                            select_all: false,
                            value: this.filterData.created_templates
                        },
                        approvers: {
                            select_all: false,
                            value: this.filterData.approvers
                        }
                    }
                }
                if (params.filters.assigned_to.value.length) {
                    params.filters.assigned_to.select_all = false
                } else {
                    params.filters.assigned_to.select_all = true
                }
                if (params.filters.on_behalf_of.value.length) {
                    params.filters.on_behalf_of.select_all = false
                } else {
                    params.filters.on_behalf_of.select_all = true
                }
                if (params.filters.product.value.length) {
                    params.filters.product.select_all = false
                } else {
                    params.filters.product.select_all = true
                }
                if (params.filters.tag.value.length) {
                    params.filters.tag.select_all = false
                } else {
                    params.filters.tag.select_all = true
                }
                if (params.filters.ticket_number.value.length) {
                    params.filters.ticket_number.select_all = false
                } else {
                    params.filters.ticket_number.select_all = true
                }
                if (params.filters.status.value.length) {
                    params.filters.status.select_all = false
                } else {
                    params.filters.status.select_all = true
                }
                if (params.filters.template.value.length) {
                    params.filters.template.select_all = false
                } else {
                    params.filters.template.select_all = true
                }
                if (params.filters.approvers.value.length) {
                    params.filters.approvers.select_all = false
                } else {
                    params.filters.approvers.select_all = true
                }
                if (String(this.$route.path).startsWith('/pm')) {
                    params['is_maintenance'] = true;
                }
                let res = await this.getAllTickets(params)
                this.allTickets = res.response.all_tickets
                this.total = res.response.total_no_of_tickets
                this.total_pages = parseInt(res.response.total_no_of_tickets / this.limit)
                // this.changePage()
                
                this.status_based_total = res.response.total_no_of_tickets
                this.ajaxCallInProgress = false
            } catch (reason) {
                console.log(reason)
            }
        },
        ticketDelete(ticket) {
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to archieve" + ' ' + JSON.stringify(ticket.ticket_number) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'YES',
                cancelButtonText: 'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        ticket_id: ticket.ticket_id
                    }
                    this.confirmDelete(params)
                }
            })
        },
        async confirmDelete(params) {
            try {
                this.ajax_loader = true
                let res = await this.deleteTicket(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.ajax_loader = false
                    EventBus.$emit('RecallStatusTabs')
                    this.getAllTicketAPI();
                }, 3000);
            } catch (reason) {
                this.ajax_loader = false
                this.warning_msg = 'Only Closed Tickets can be Archived'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        }
    },
    computed: {
        getSkipCount() {
            if (this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    watch: {
        limit: function () {
            this.getAllTicketAPI();
        }
    },
    async mounted() {
        for (let i = 10; i <= 50; i += 10) {
            this.pageLimit.push(i);
        }
        if (localStorage.getItem('StoreFilterData')) {
            let FilterData = JSON.parse(localStorage.getItem('StoreFilterData'));
            this.showfilterData = FilterData.showfilterData;
            this.filterData = FilterData.filterData;
        }
        this.getAllTicketAPI()
        EventBus.$on('updateTableView', status => {
            if (status.is_tab_selected) {
                this.filterData.status = status.status_tab
            }
            if (status.dashboard_filter) {
                this.filterData.created_tags = status.dashboard_filter.filterData.created_tags,
                    this.filterData.created_templates = status.dashboard_filter.filterData.created_templates,
                    this.showfilterData.created_tags = status.dashboard_filter.showfilterData.created_tags,
                    this.showfilterData.created_templates = status.dashboard_filter.showfilterData.created_templates
            }
            this.skip = 0
            this.getAllTicketAPI()
        })
        EventBus.$on('updateTableViewTab', status => {
            this.getAllTicketAPI();
        })
    },
    destroyed() {
        EventBus.$off('updateTableViewTab');
        EventBus.$off('updateTableView');
    }
}
</script>
<style scoped>
.table-new-template tbody tr td {
    width: 10% !important;
}

.mw-200px {
    min-width: 200px !important;
}

.overflow-visible {
    overflow: scroll !important;
}

.ht-100px {
    height: 100px;
}

.inverse div {
    position: absolute;
    top: 27px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #005dae;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

span.caps::first-letter {
    text-transform: uppercase !important;
}
</style>